import { useQuery } from '@apollo/client';
import { RoleByIdDocument, RoleByIdQuery } from 'src/graphql/generated/graphql';

interface UseRoleByIdProps {
  id: string;
}

export const useRoleById = (props: UseRoleByIdProps) => {
  const { id } = props || {};

  const { data, loading } = useQuery<RoleByIdQuery>(RoleByIdDocument, {
    variables: {
      id,
    },
    skip: !id,
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-only',
  });

  return {
    role: data?.roleById,
    loading,
  };
};
